import {createApiClient} from "./index";
import {ApiEnvType} from "types/filterContext";

export interface TenantIdsQueryParams {
    token: string;
    apiKey?: string;
}

export const tenantsApi = {
    async getTenantIds({token, apiKey = 'dev-us'}: TenantIdsQueryParams, signal?: AbortSignal): Promise<string[]> {
        const api = createApiClient(apiKey as ApiEnvType);

        const response = await api.get('/tenants/ids', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            signal,
        });
        return response.data;
    },
};
